import { FC, Dispatch, SetStateAction } from "react";

interface ISeaportCollapsables {
  team_member: boolean;
  team_experience: boolean;
  quality_assurance: boolean;
}

interface IProps {
  isCollapsed: ISeaportCollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ISeaportCollapsables>>;
}

export const QualityAssurance: FC<IProps> = ({
  isCollapsed,
  setIsCollapsed,
}) => {
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            quality_assurance: !isCollapsed.quality_assurance,
          })
        }
        className="collapsable"
      >
        Quality Assurance
        <i
          className={
            isCollapsed.quality_assurance
              ? "fas fa-caret-down"
              : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.quality_assurance ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                quality_assurance: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="qa-content">
          <p className="qa-content__subheader">
            PROSOFT employs stringent Quality Assurance (QA) through our
            ISO-9001:2015 certified Quality Management System (QMS). Our
            certification history and QMS highlights are annotated from recent
            to past:
          </p>
          <ul>
            <li>
              December 2017, PROSOFT recertified to the ISO-9001:2015 standard.
              The recertification is valid for three years with successful
              compliance. Formal registrar Surveillance Audits are scheduled
              annually to verify compliance. PROSOFT's Project Management and
              Design and Development sections are audited each time, as well as
              the Corrective and Preventive Action Process.
            </li>
            <li>
              January 2015, PROSOFT recertified to the ISO-9001:2008 standard.
              The recertification is valid for three years with successful
              compliance. Formal registrar Surveillance Audits are scheduled
              annually to verify compliance. PROSOFT's Project Management and
              Design and Development sections are audited each time, as well as
              the Corrective and Preventive Action Process.
            </li>
            <li>
              January 2012, PROSOFT recertified to the ISO-9001:2008 standard.
              The recertification is valid for three years with successful
              compliance. Formal registrar Surveillance Audits are scheduled
              every six months to verify compliance. PROSOFT's Project
              Management and Design and Development sections are audited each
              time, as well as the Corrective and Preventive Action Process.
            </li>
            <li>
              November 2009, PROSOFT achieved ISO-9001:2008 certification. This
              was a succession to the predecessor ISO 9001:2000 standard which
              PROSOFT was certified to for four years. The new certification is
              valid for three years with successful compliance. Formal registrar
              Surveillance Audits are scheduled every six months to verify
              compliance. PROSOFT's Project Management and Design and
              Development sections are audited each time, as well as the
              Corrective and Preventive Action Process.
            </li>
            <li>
              December 2008, PROSOFT achieved ISO 9001:2000 Re-certification for
              the company Quality Management System (QMS) in two office
              locations and three business areas: Systems/Software Engineering,
              Networking and Telecommunications, and Training Development. A
              formal external audit performed by ANAB-accredited SGS Group
              stated "The audit team concludes that the organization has
              established and maintained its management system in line with the
              requirements of the standard and demonstrated the ability of the
              system to systematically achieve agreed requirements for products
              or services within the scope and the organization's policy and
              objectives." The audit team conducted a process-based audit
              focusing on significant aspects/risks/objectives required by the
              standard(s). The audit methods used were interviews, observation
              of activities and review of documentation and records.
              Program/Project Management and large-scale and small-scale
              Software and Training Design and Development projects were
              reviewed. The PROSOFT QMS contains a total 44 Quality System
              Procedures, 43 Work Instructions, over 100 supporting documents,
              and numerous quality records. PROSOFT maintained certification as
              validated by five successful Surveillance Audits performed by SGS
              Group on a six-month review cycle from the date of initial
              certification to re-certification.
            </li>
            <li>
              November 2005, PROSOFT achieved ISO 9001:2000 certification for
              the company Quality Management System (QMS) in two office
              locations and three business areas: Systems/Software Engineering,
              Networking and Telecommunications, and Training Development
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
